export const regions = [
  "Imphal West",
  "Imphal East",
  "Thoubal",
  "Kakching",
  "Bishnupur",
  "Senapati",
  "Kangpokpi",
  "Churachandpur",
  "Kamjong",
  "Jiribam",
  "Nongpoh",
  "Pherzawl",
  "Tamenglong",
  "Ukhrul",
];
export const mainData = [
  {
    "region": "CHANDEL",
    "hf_complete": 3,
    "hf_started": 4,
    "village_complete": 98,
    "village_started": 102
  },
  {
    "region": "BISHNUPUR",
    "hf_complete": 4,
    "hf_started": 20,
    "village_complete": 31,
    "village_started": 95
  },
  {
    "region": "IMPHAL WEST",
    "hf_complete": 30,
    "hf_started": 67,
    "village_complete": 216,
    "village_started": 407
  },
  {
    "region": "KAKCHING",
    "hf_complete": 10,
    "hf_started": 22,
    "village_complete": 73,
    "village_started": 120
  },
  {
    "region": "KAMJONG",
    "hf_complete": 0,
    "hf_started": 3,
    "village_complete": 0,
    "village_started": 8
  },
  {
    "region": "TENGNOUPAL",
    "hf_complete": 0,
    "hf_started": 8,
    "village_complete": 0,
    "village_started": 43
  },
  {
    "region": "IMPHAL EAST",
    "hf_complete": 6,
    "hf_started": 56,
    "village_complete": 84,
    "village_started": 298
  },
  {
    "region": "TAMENGLONG",
    "hf_complete": 0,
    "hf_started": 1,
    "village_complete": 0,
    "village_started": 19
  },
  {
    "region": "PHERZAWL",
    "hf_complete": 0,
    "hf_started": 1,
    "village_complete": 0,
    "village_started": 5
  },
  {
    "region": "SENAPATI",
    "hf_complete": 1,
    "hf_started": 11,
    "village_complete": 6,
    "village_started": 51
  },
  {
    "region": "KANGPOKPI",
    "hf_complete": 0,
    "hf_started": 2,
    "village_complete": 0,
    "village_started": 13
  },
  {
    "region": "THOUBAL",
    "hf_complete": 13,
    "hf_started": 51,
    "village_complete": 127,
    "village_started": 232
  },
  {
    "region": "JIRIBAM",
    "hf_complete": 0,
    "hf_started": 2,
    "village_complete": 3,
    "village_started": 0
  }
];


export const hfMainData = mainData?.sort((a, b) => a.hf_started - b.hf_started)
export const villageMainData = mainData?.sort((a, b) => a.village_started - b.village_started)

export const donutData = [
  { id: 0, value: 30, label: "Tamenglong 30%", color: "#2196f3" },
  { id: 1, value: 20, label: "Bishnupur 20%", color: "#4caf50" },
  { id: 2, value: 20, label: "Jiribam 20%", color: "#ff9800" },
  { id: 3, value: 20, label: "Kangpokpi 20%", color: "#f44336" },
  { id: 4, value: 5, label: "Kamjong 5%", color: "#9c27b0" },
  { id: 5, value: 3, label: "Pherzawl 3%", color: "#00bcd4" },
  { id: 6, value: 2, label: "Kangpokpi 2%", color: "#795548" },
];

export const tabsData = [
  {
    label: "Home",
    value: null,
  },
  {
    label: "HTN",
    value: 0,
  },
  {
    label: "DM",
    value: 1,
  },
  {
      label: "CVD",
      value: 3,
    },
    {
        label: "CKD",
        value: 4,
    },
    {
        label: "COPD",
        value: 5,
    },
    {
        label: "Post Stroke",
        value: 6,
    },
    {
        label: "Mental Health",
        value: 7,
    },
    {
      label: "DM With HTN",
      value: 2,
    },
  // {
  //   label: "Risk Of Having NCD",
  //   value: 8,
  // },
  {
    label: "BMI>=25",
    value: 8,
  },
  {
    label: "Cancer",
    value: 9,
  },
];

export const districts = [
  { label: "ALL DISTRICTS", value: "ALL" },
  { label: "IMPHAL WEST", value: "IMPHAL WEST" },
  { label: "IMPHAL EAST", value: "IMPHAL EAST" },
  { label: "THOUBAL", value: "THOUBAL" },
  { label: "KAKCHING", value: "KAKCHING" },
  { label: "BISHNUPUR", value: "BISHNUPUR" },
  { label: "CHANDEL", value: "CHANDEL" },
  { label: "SENAPATI", value: "SENAPATI" },
  { label: "KANGPOKPI", value: "KANGPOKPI" },
  { label: "TENGNOUPAL", value: "TENGNOUPAL" },
  { label: "TAMENGLONG", value: "TAMENGLONG" },
  { label: "JIRIBAM", value: "JIRIBAM" },
  { label: "PHERZAWL", value: "PHERZAWL" },
  { label: "KAMJONG", value: "KAMJONG" }
];


export const HomeHeader = [
  { label: "Total Population Screened", key: "total_population_screened" },
  { label: "Total Number Of District Covered", key: "districts_covered" },
  { label: "Total Number Of Villages Where CMHA Screening Started", key: "villages_screening_started" },
//   { label: "Total Number Of Villages Where CMHA Screening Has Completed", key: "villages_screening_completed" },
//   { label: "Number Of Villages Completed in Percentage", key: "villages_completed_in_percent" },
  { label: "Total Number Of Health Facility Where CMHA Screening Started", key: "health_facility_screening_started" },
//   { label: "Total Number Of Health Facility Where CMHA Screening Has Completed", key: "health_facility_screening_completed" },
//   { label: "Number Of Health Facility Completed in Percentage", key: "health_facility_completed_in_percent" },
]
